import cabecalho from '@/components/global/Cabecalho/Cabecalho.vue'
import menuLateral from '@/components/global/MenuLateral/MenuLateral.vue'
import spinnerProcessando from '@/components/layout/spinnerProcessamento/SpinnerProcessamento.vue'
import { BSpinner, BToast } from 'bootstrap-vue'
import defaultTable from '@/components/layout/defaultTable/DefaultTable.vue'
import util from '@/util'
import mensagens from '@/util/mensagens'
import VueTheMask from 'vue-the-mask'

export default {
  name: 'modal-cancelamento',
  components: {
    cabecalho,
    menuLateral,
    spinnerProcessando,
    'b-toast': BToast,
    'default-table': defaultTable,
    'b-spinner': BSpinner
  },
  computed: {},
  data: () => {
    return {
      aceitou: false,
      gerenciadoPeloEscritorio: false,
      contrato: null,
      email: null,
      id_contrato: null,
      modal_cancelamento: {
        mensagem: null,
        contrato_id: null,
        aceitou: false,
        loading: false
      },
      formulario: {
        codigo: null,
        cancelar_imediato: false,
        token: null
      },
      principal: '0'
    }
  },
  directives: { VueTheMask },
  mounted () {},
  props: ['resumoContrato', 'isVencido'],
  methods: {
    alterarPlano () {
      this.$router.push({ name: 'alterar-plano-contrato' })
    },
    abrirModal (token, principal = '0', dados = null) {
      this.formulario.codigo = ''
      this.formulario.token = ''

      this.formulario.token = token
      this.contrato = dados.contrato
      this.id_contrato = dados.id_contrato
      this.principal = principal

      // Contexto Office
      if (dados.gerenciadoPeloEscritorio !== undefined) {
        this.gerenciadoPeloEscritorio = dados.gerenciadoPeloEscritorio
        this.email = dados.email
      }
      this.$refs.modal_cancelamento.show()
    },
    async enviarEmail () {
      this.modal_cancelamento.aceitou = true
      this.modal_cancelamento.loading = true
      try {
        let resposta = null

        if (this.gerenciadoPeloEscritorio) {
          resposta = await this.axios.post(`/escritorios/escritorio/verifica/cancelamento`, { contrato_id: this.id_contrato, email: this.email, empresa_id: this.$route.params.id })
        } else {
          resposta = await this.axios.post(`/manager/conta/contrato/verifica/cancelamento`, { contrato_id: this.id_contrato })
        }

        if (resposta.data.retorno.sucesso) {
          this.formulario.token = resposta.data.retorno.listaDados.token
          util.criarAlertaToastDeSucesso(this, 'Aviso', resposta.data.retorno.mensagem)
        } else {
          util.criarAlertaToastDeErro(this, 'Aviso', resposta.data.retorno.mensagem)
        }
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
        this.modal_cancelamento.aceitou = false
      }
      this.modal_cancelamento.loading = false
    },
    async cancelarContrato () {
      this.modal_cancelamento.aceitou = true
      this.modal_cancelamento.loading = true
      this.modal_cancelamento.mensagem = null
      try {
        let resposta = null

        if (this.gerenciadoPeloEscritorio) {
          this.formulario = { ...this.formulario, email: this.email, contrato_id: this.id_contrato }
          resposta = await this.axios.post(`/escritorios/escritorio/cancelar`, this.formulario)
        } else {
          resposta = await this.axios.post(`/manager/conta/contrato/cancelar`, this.formulario)
        }

        if (resposta.data.retorno.sucesso) {
          this.modal_cancelamento.mensagem = resposta.data.retorno.mensagem

          util.criarAlertaToastDeSucesso(this, 'Aviso', resposta.data.retorno.mensagem)

          this.$refs.modal_cancelamento.hide()
          this.$emit('obterResumoContrato')
        } else {
          util.criarAlertaToastDeErro(this, 'Aviso', resposta.data.retorno.mensagem, true, 20000)
          this.modal_cancelamento.mensagem = resposta.data.retorno.mensagem
        }
      } catch (e) {
        if (e.response.status === 400) {
          util.criarAlertaToastDeErro(this, 'Aviso', e.response.data.retorno.mensagem)
        } else {
          util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
        }
        this.modal_cancelamento.aceitou = false
      }
      this.modal_cancelamento.loading = false
    }
  }
}
